/* Keep collection colorway previews in sync with their swatches. */
(() => {
  const originals = new WeakMap();
  const attributes = ['src', 'srcset', 'data-src', 'data-srcset', 'data-sizes', 'sizes'];

  function imageFor(card) {
    return card.querySelector('.product_image .image__container .image-element__wrap img');
  }

  function update(card, swatch) {
    const label = card.querySelector('[data-colorway-label]');
    if (label) label.textContent = swatch?.dataset.colorway || label.dataset.activeColorway;

    const image = imageFor(card);
    if (!image) return;
    if (!originals.has(image)) {
      originals.set(image, Object.fromEntries(attributes.map(name => [name, image.getAttribute(name)])));
    }
    const url = swatch?.dataset.variantImage;
    if (url) {
      image.setAttribute('src', url);
      image.setAttribute('srcset', url);
      image.setAttribute('data-src', url);
      image.setAttribute('data-srcset', url);
      image.removeAttribute('data-sizes');
      image.removeAttribute('sizes');
    } else {
      const original = originals.get(image);
      for (const name of attributes) {
        if (original[name] === null) image.removeAttribute(name);
        else image.setAttribute(name, original[name]);
      }
    }
  }

  function swatchFrom(target) {
    return target instanceof Element ? target.closest('.collection-card .collection_swatches .swatch') : null;
  }

  document.addEventListener('pointerover', event => {
    const swatch = swatchFrom(event.target);
    if (!swatch || swatch.contains(event.relatedTarget)) return;
    update(swatch.closest('.collection-card'), swatch);
  });
  document.addEventListener('pointerout', event => {
    const swatch = swatchFrom(event.target);
    if (!swatch || swatch.contains(event.relatedTarget)) return;
    const card = swatch.closest('.collection-card');
    update(card, swatchFrom(event.relatedTarget)?.closest('.collection-card') === card ? swatchFrom(event.relatedTarget) : null);
  });
  document.addEventListener('focusin', event => {
    const swatch = swatchFrom(event.target);
    if (swatch) update(swatch.closest('.collection-card'), swatch);
  });
  document.addEventListener('focusout', event => {
    const swatch = swatchFrom(event.target);
    if (!swatch) return;
    const card = swatch.closest('.collection-card');
    update(card, swatchFrom(event.relatedTarget)?.closest('.collection-card') === card ? swatchFrom(event.relatedTarget) : null);
  });
})();
